var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "app-main-content",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading"
      }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _vm.$store.getters.enableFrontEndPlugin
            ? _c(
                "div",
                [
                  _c("micro-app", {
                    attrs: {
                      name: "child-ar-WriteOffStatus-Query-ReleaseManagement",
                      url:
                        _vm.$store.getters.frontEndPluginUrl +
                        "/arWriteOffStatusQuery",
                      "router-mode": "pure",
                      destroy: ""
                    },
                    on: { datachange: _vm.arWriteOffStatusQueryDataChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.showView
            ? _c(
                "el-tabs",
                {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _vm.singleReleaseVerifyView
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_MBLReleaseReview"),
                            name: "singleReleaseVerifyView"
                          }
                        },
                        [
                          _c("single-release-verify-view", {
                            attrs: {
                              "tab-name": "singleReleaseVerifyView",
                              "tab-title": _vm.$t(
                                "CargoMsg.Cargo_MBLReleaseReview"
                              ),
                              "ar-write-off-status-query-search":
                                _vm.arWriteOffStatusQuerySearch,
                              "ar-write-off-status-query-column":
                                _vm.arWriteOffStatusQueryColumn
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.singleReleaseView
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            lazy: true,
                            label: _vm.$t(
                              "CargoMsg.Cargo_MBLReleaseManagement"
                            ),
                            name: "singleReleaseView"
                          }
                        },
                        [
                          _c("single-release-view", {
                            attrs: {
                              "tab-name": "singleReleaseView",
                              "tab-title": _vm.$t(
                                "CargoMsg.Cargo_MBLReleaseManagement"
                              ),
                              "ar-write-off-status-query-search":
                                _vm.arWriteOffStatusQuerySearch,
                              "ar-write-off-status-query-column":
                                _vm.arWriteOffStatusQueryColumn
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.singleReleaseVerifyViewHbl
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_HBLReleaseReview"),
                            name: "singleReleaseVerifyViewHbl"
                          }
                        },
                        [
                          _c("single-release-verify-view-hbl", {
                            attrs: {
                              "tab-name": "singleReleaseVerifyViewHbl",
                              "tab-title": _vm.$t(
                                "CargoMsg.Cargo_HBLReleaseReview"
                              ),
                              "ar-write-off-status-query-search":
                                _vm.arWriteOffStatusQuerySearch,
                              "ar-write-off-status-query-column":
                                _vm.arWriteOffStatusQueryColumn
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.hblSingleReleaseView
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            lazy: true,
                            label: _vm.$t(
                              "CargoMsg.Cargo_HBLReleaseManagement"
                            ),
                            name: "hblSingleReleaseView"
                          }
                        },
                        [
                          _c("hbl-single-release-view", {
                            attrs: {
                              "tab-name": "hblSingleReleaseView",
                              "tab-title": _vm.$t(
                                "CargoMsg.Cargo_HBLReleaseManagement"
                              ),
                              "ar-write-off-status-query-search":
                                _vm.arWriteOffStatusQuerySearch,
                              "ar-write-off-status-query-column":
                                _vm.arWriteOffStatusQueryColumn
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }